import httpService from "./http-service";

export default {
  getAcademicProcedures(id) {
    return httpService.get(`student/academic-procedures-list/${id}`);
  },
  createAcademicProcedure(payload) {
    return httpService.post(`student/academic-procedures`, payload);
  },
  updateAcademicProcedure(uuid, payload) {
    return httpService.put(`student/academic-procedures/${uuid}`, payload);
  },
  deleteAcademicProcedure(uuid) {
    return httpService.delete(`student/academic-procedures/${uuid}`);
  },
  getAcademicProcedure(uuid) {
    return httpService.get(`student/academic-procedures/${uuid}`);
  },
  getAcademicProcedurePayments(uuid) {
    return httpService.get(`student/academic-procedures/${uuid}/payments`);
  },
  getFlyWirePaymentOrder(payment) {
    return httpService.post(
      `student/academic-procedures/${payment.procedureId}/payments`,
      payment
    );
  },
};
